import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import Colors from '../../../../styles/colors';
import commonStyles from '../../../../styles/commonStyles';
import { STATIC_HOMEPAGE_URL } from '../../../../config';
import { Select } from '../shared/styled-components';
const { convertDecimalCommasToDots } = require('../../../../../server/scripts/utils.js')();

class Coupons extends Component {
  generateCodeLink(code) {
    const { soundcastId } = this.props;
    return `${STATIC_HOMEPAGE_URL}/soundcasts/${soundcastId}/?c=${code}`;
  }

  getDiscountedPrice(item, coupon) {
    const nprice = item.price * (100 - coupon.percentOff) / 100;
    return Number(nprice).toFixed(2);
  }

  stripNonAlphanumeric(str) {
    return str.replace(/[^A-Za-z0-9_\-]/g, '');
  }

  render() {
    const {
      price,
      prices,
      onChange,
      soundcastId,
      priceIndex: i,
    } = this.props;

    if (isEmpty(price.coupons)) return null;

    const isSubscription = !['one time', 'rental'].includes(price.billingCycle);
    return (
      <div style={{marginTop: 5}}>
        {price.coupons.map((coupon, j) => (
          <div style={styles.couponWrapper} key={`price${i}coupon${j}`}>
            <div style={styles.couponInnerWrapper}>
              <div style={styles.couponCode}>
                <span>Coupon Code (no space)</span>
                <div>
                  <input
                    type="text"
                    style={styles.inputTitle}
                    name="couponCode"
                    onChange={e => {
                      const code = e.target.value || '';
                      prices[i].coupons[j].code = this.stripNonAlphanumeric(code);
                      onChange(prices);
                    }}
                    value={price.coupons[j].code}
                  />
                </div>
              </div>
              <div style={styles.couponType}>
                <span>Coupon Type</span>
                <div>
                  <Select
                    type="text"
                    style={{ ...styles.inputTitle, paddingTop: 6 }}
                    name="couponType"
                    onChange={e => {
                      prices[i].coupons[j].couponType = e.target.value;
                      onChange(prices);
                    }}
                    value={price.coupons[j].couponType}
                  >
                    <option value="discount">Discount</option>
                    {isSubscription && <option value="trial_period">Trial Period</option>}
                  </Select>
                </div>
              </div>
              {(!coupon.couponType || coupon.couponType === 'discount') && (
                <div style={styles.discountPercent}>
                  <span>Discount Percent</span>
                  <div>
                    <input
                      type="text"
                      style={{ ...styles.inputTitle, width: '50%' }}
                      name="discountPercent"
                      onChange={e => {
                        const value = convertDecimalCommasToDots(e.target.value || '');
                        prices[i].coupons[j].percentOff = value;
                        onChange(prices);
                      }}
                      value={price.coupons[j].percentOff}
                    />
                    <span style={{ fontSize: 18 }}>{` % off`}</span>
                  </div>
                </div>
              )}
              {(!coupon.couponType || coupon.couponType === 'discount') && (
                <div style={styles.discount}>
                  <span>Price After Discount</span>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: 14,
                    }}
                  >
                    <span style={{ fontSize: 20 }}>
                      {`${('currency' in price ? price.currency : 'USD')} ${this.getDiscountedPrice(price, price.coupons[j])}`}
                    </span>
                  </div>
                </div>
              )}
              {coupon.couponType === 'trial_period' && (
                <div style={styles.trialPeriod}>
                  <span>Trial length</span>
                  <div>
                    <input
                      type="text"
                      style={{ ...styles.inputTitle, width: '56%' }}
                      name="trialLength"
                      onChange={e => {
                        prices[i].coupons[j].trialLength = e.target.value;
                        onChange(prices);
                      }}
                      value={price.coupons[j].trialLength || 0}
                    />
                    <span style={{ fontSize: 18 }}>{` Days`}</span>
                  </div>
                </div>
              )}
              <div
                style={styles.expiration}
              >
                <span>Expires on</span>
                <div className="dateTimeInput" style={{ minWidth: 145, marginTop: 5 }}>
                  <Datetime
                    value={moment.unix(coupon.expiration)}
                    onChange={date => {
                      if (date.unix) {
                        prices[i].coupons[j].expiration = date.unix();
                        onChange(prices);
                      }
                    }}
                  />
                </div>
              </div>

              <div style={{ marginTop: 30 }}>
                <span
                  style={styles.removeBtn}
                  onClick={() => {
                    prices[i].coupons.splice(j, 1);
                    onChange(prices);
                  }}
                >
                  <i className="fa fa-times " aria-hidden="true" />
                </span>
              </div>
            </div>
            {soundcastId && (
              <div style={{ marginRight: 10 }}>
                <a
                  style={styles.codeLink}
                  target="_blank"
                  href={this.generateCodeLink(prices[i].coupons[j].code)}
                >
                  Promo Landing Page
                </a>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }
}

const styles = {
  inputTitle: { ...commonStyles.inputTitle, marginTop: 5 },
  couponWrapper: {
    backgroundColor: '#fff',
    border: '3px dashed #eee',
    padding: 20,
    borderRadius: 5,
    marginBottom: 5,
  },
  couponInnerWrapper: {
    width: '100%',
    marginTop: 5,
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  codeLink: {
    color: Colors.link,
    fontWeight: 700,
    fontSize: 14,
    display: 'inline-block',
  },
  couponCode: {
    marginRight: 10,
    width: 200,
    minWidth: 200,
  },
  couponType: {
    marginRight: 10,
    width: 160,
    minWidth: 160,
  },
  discountPercent: {
    marginRight: 13,
    width: 110,
    minWidth: 110,
  },
  discount: {
    marginRight: 13,
    height: 67,
    width: 125,
    minWidth: 125,
  },
  trialPeriod: {
    marginRight: 13,
    marginLeft: 13,
    width: 115,
    minWidth: 115,
  },
  expiration: {
    marginRight: 10,
    height: 67,
    width: 195,
    minWidth: 195,
  },
  removeBtn: {
    marginLeft: 5,
    cursor: 'pointer',
    fontSize: 20,
  },
};

Coupons.propTypes = {
  soundcastId: PropTypes.string,
  price: PropTypes.object,
  prices: PropTypes.array,
  priceIndex: PropTypes.number,
  onChange: PropTypes.func,
};

Coupons.defaultProps = {
  soundcastId: '',
  price: {},
  prices: [],
  priceIndex: 0,
  onChange: () => {},
};

export default Coupons;
